<template>
  <div class="home_">
    <div
      class="home"
      :style="
        dialogFormLogin || dialogFormIllustrate || dialogFormInformation
          ? 'height:100vh;overflow:hidden'
          : ''
      "
    >
      <div class="home_box">
        <!--  v-if="!dialogFormIllustrate && !dialogFormInformation && !dialogFormLogin" -->
        <div class="home_header">
          <div class="home_left">ChatLearning</div>
          <div class="home_right">
            <el-button
              type="text"
              style="color: #5e6d82"
              v-if="login_show"
              @click="loginUser"
              >登录</el-button
            >
            <!-- <el-button type="text" style="color: #5e6d82" v-if="login_show" @click="loginUser"
            >登录</el-button
          > -->
          </div>
        </div>
        <div class="subject_car">
          <div class="car_tit">
            <img
              style="width: 45px"
              src="../assets/img/学科图标/必修科目.png"
              alt=""
            />
            <div class="tit_txt">必修科目</div>
          </div>
          <div class="car_box">
            <div
              class="compulsory_left"
              style="background: #e6b6c9"
              @click="
                goKind({
                  name: '英语',
                  ordinal: 3,
                  id: 3,
                })
              "
            >
              <div class="compulsory_tit" style="color: white">识物英语</div>
              <img
                style="max-width: 120px; margin: 0 auto; width: 80%"
                src="../assets/img/学科图标/英语.png"
                alt=""
              />
            </div>
            <div class="compulsory_right">
              <div
                class="compulsory_right_son"
                style="background: #fdf993; margin: 0 0 10px 0"
                @click="
                  goKind({
                    name: '语文',
                    ordinal: 1,
                    id: 1,
                  })
                "
              >
                <div class="compulsory_tit" style="color: #dd9e24">语文</div>
                <div class="img_r">
                  <img
                    style="max-width: 80px; width: 60%"
                    src="../assets/img/学科图标/语文.png"
                    alt=""
                  />
                </div>
              </div>
              <div
                class="compulsory_right_son"
                style="background: #607dbf"
                @click="
                  goKind({
                    name: '数学',
                    ordinal: 2,
                    id: 2,
                  })
                "
              >
                <div class="compulsory_tit" style="color: rgb(4 34 103)">
                  数学
                </div>
                <div class="img_r">
                  <img
                    style="max-width: 80px; width: 60%"
                    src="../assets/img/学科图标/数学.png"
                    alt=""
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="subject_car" v-if="majorSubjects.length > 0">
          <div class="car_tit">
            <img
              style="width: 45px"
              src="../assets/img/学科图标/主修科目.png"
              alt=""
            />
            <div class="tit_txt">主要科目</div>
          </div>
          <div class="major_s">
            <div
              class="major_son"
              v-for="(item, index) in majorSubjects"
              :key="index"
              @click="goSearch(item)"
            >
              <div
                class="major_img"
                :style="
                  index == 1
                    ? 'background: #6B87A1;'
                    : index == 2
                    ? 'background: #BCDB9E;'
                    : 'background: #66CCFF;'
                "
              >
                <img
                  :src="require(`../assets/img/学科图标/${item.name}.png`)"
                  alt=""
                />
              </div>

              <div class="major_tit">
                {{ item.name }}
              </div>
            </div>
          </div>
        </div>
        <div class="subject_car">
          <div class="car_tit">
            <img
              style="width: 45px"
              src="../assets/img/学科图标/其他科目.png"
              alt=""
            />
            <div class="tit_txt">其他科目</div>
          </div>
          <div class="other_s">
            <div
              class="other_"
              v-for="(item, index) in otherSubjects"
              :key="index"
            >
              <div class="other_tag" @click="goSearch(item)">
                {{ item.name }}
              </div>
            </div>
          </div>
        </div>

        <div class="subject_car">
          <div class="car_tit">
            <img
              style="width: 35px; margin: 0 3px 0 7px"
              src="../assets/img/three/ChatMedia.png"
              alt=""
            />
            <div class="tit_txt">实用学习工具</div>
          </div>
          <div class="Media_css" @click="goMedia">
            <div class="Media_left">
              <h3 class="tit_txt" style="letter-spacing: 0px">
                ChatMedia视频学习
              </h3>
              <p>支持BiliBili、今日头条等多种视频网站上传，快速总结视频要点</p>
            </div>
            <div class="Media_right">
              <img src="../assets/img/three/右_right.png" alt="" />
            </div>
          </div>
        </div>
      </div>
      <div
        class="levitating_css"
        v-if="
          !dialogFormIllustrate && !dialogFormInformation && !dialogFormLogin
        "
      >
        <!-- <div class="ball_s">
        <div class="ball_css" @click="goBasket"><span>试题篮</span></div>
        <div class="ball_css" @click="goPersonal">
          <span
            >个人 <br />
            中心</span
          >
        </div>
      </div> -->
      </div>
      <ComFooter class="footer_css"></ComFooter>
    </div>

    <el-dialog
      class="dialogLogin"
      :close-on-click-modal="false"
      :visible.sync="dialogFormLogin"
    >
      <div class="dialog_tit">登录 / 注册</div>
      <el-form
        v-if="dialogFormLogin"
        :model="formLogin"
        :rules="rulesLogin"
        ref="formLogin"
      >
        <el-form-item label="手机号" :label-width="formLabelWidth" prop="phone">
          <el-input v-model="formLogin.phone" autocomplete="off"
            ><span
              v-if="!countDown"
              @click="getCode"
              slot="suffix"
              style="font-size: 12px"
              class="el-input__icon"
              >获取验证码</span
            >
            <span
              v-else
              slot="suffix"
              class="el-input__icon"
              style="font-size: 12px"
              >{{ countDown }}s 重新获取</span
            ></el-input
          >
        </el-form-item>
        <el-form-item label="验证码" :label-width="formLabelWidth" prop="code">
          <el-input v-model="formLogin.code" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          style="background: #169bd5"
          type="primary"
          @click="submitLogin('formLogin')"
          >确 定</el-button
        >
      </div>
    </el-dialog>
    <el-dialog
      class="dialogIllustrate"
      :modal="true"
      :close-on-click-modal="false"
      :visible.sync="dialogFormIllustrate"
    >
      <div class="dialog_tit" style="background: #7a92c9">使用说明</div>
      <div class="conIllustrate_css">
        <div class="conIllustrate" v-if="Illustrate === 0">
          <!-- <div class="imgIllustrate"></div> -->
          <p class="Illustrate_p">
            在您阅读完本说明并关闭后，将会弹出信息填写界面，为方便您后续使用，请仔细阅读本说明。
          </p>
          <p class="Illustrate_p">
            信息填写页共有昵称、年级、地区、主要科目五项，除主要科目外，其余均为必填项
          </p>
        </div>
        <div class="conIllustrate" v-else-if="Illustrate === 1">
          <div class="imgIllustrate">
            <img class="dia_img" src="../assets/img/home_1.png" alt="" />
          </div>
          <p class="Illustrate_p">在这里您可以自由地为自己起一个好听的昵称。</p>
          <p class="Illustrate_p">
            但请您注意，您所起的昵称需要符合相关法律法规，否则将被屏蔽，严重时将被封号。
          </p>
          <p class="Illustrate_p">您可以在个人设置中随时修改昵称</p>
        </div>
        <div class="conIllustrate" v-else-if="Illustrate === 2">
          <div class="imgIllustrate">
            <img class="dia_img" src="../assets/img/home_2.png" alt="" />
          </div>
          <p class="Illustrate_p">
            在这里您需要为自己主要的学习方向做一个年级的选择，在未来您使用搜题功能时，这将影响题目呈现的顺序。当然您也可以在搜题时随时修改对应年级以便提前预习和了解。
          </p>
          <p class="Illustrate_p">
            每年9月1日，您的年级将自动加一。例如您于2023年10月1日注册时选择了小学六年级，那么在2024年9月1日将自动升为初中一年级。
          </p>
          <p class="Illustrate_p">您可以在个人设置中随时修改年级。</p>
        </div>
        <div class="conIllustrate" v-else-if="Illustrate === 3">
          <div class="imgIllustrate">
            <img class="dia_img" src="../assets/img/home_3.png" alt="" />
          </div>
          <p class="Illustrate_p" style="margin: 30px 0 0 0">
            在这里您需要为自己设置主要科目，例如您所在的地区施行“6选3”机制，那么我们建议您选择高考所选的三科，这将影响您首页上呈现的科目顺序，您所选择的主要科目将被优先显示。
          </p>

          <p class="Illustrate_p">您可以在个人设置中随时修改主要科目</p>
        </div>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button
          :style="
            Illustrate === 0
              ? 'color: #bcbec2;background-color: #f4f4f5;border-color: #e9e9eb'
              : 'background: #169bd5'
          "
          type="primary"
          :disabled="Illustrate === 0"
          @click="prevStep"
          >上一步</el-button
        >
        <el-button
          style="background: #169bd5; width: 84px"
          type="primary"
          @click="nextStep"
        >
          {{ Illustrate === maxStep ? " 确 认 " : "下一步" }}</el-button
        >
      </div>
    </el-dialog>
    <el-dialog
      class="dialogInformation"
      :modal="true"
      :close-on-click-modal="false"
      :visible.sync="dialogFormInformation"
    >
      <div class="dialog_tit" style="background: #7a92c9">完善信息</div>
      <el-form
        v-if="dialogFormInformation"
        :model="formInformation"
        :rules="rulesInformation"
        ref="formInformation"
        style="padding: 20px 20px 0px 20px"
        class="form_css"
      >
        <el-form-item label="昵称" prop="nickname">
          <el-input
            v-model="formInformation.nickname"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="学段" prop="stageId">
          <el-select
            v-model="formInformation.stageId"
            clearable
            placeholder="请选择学段"
            style="width: 100%"
            @change="stagesChange"
          >
            <el-option
              v-for="item in stagesOptions"
              :key="item.cordinal"
              :label="item.name"
              :value="item.ordinal"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <p class="Information_p">
          年级决定了未来搜题的主要知识点分布和难度，请认真填写
        </p>
        <el-form-item
          label="年级"
          v-if="
            formInformation.stageId &&
            (formInformation.stageId == 2 ||
              formInformation.stageId == 3 ||
              formInformation.stageId == 4)
          "
          prop="grades"
        >
          <el-select
            v-model="formInformation.gradeId"
            clearable
            placeholder="请选择年级"
            style="width: 100%"
          >
            <el-option
              v-for="item in gradesOptions"
              :key="item.ordinal"
              :label="item.name"
              :value="item.ordinal"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="地区" prop="provinceI">
          <el-select
            v-model="formInformation.provinceId"
            clearable
            placeholder="请选择地区"
            style="width: 100%"
          >
            <el-option
              v-for="item in provinceOptions"
              :key="item.code"
              :label="item.name"
              :value="item.code"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <p class="Information_p">
          地区决定了未来搜题的主要来源，如：北京卷，全国新课标甲卷等，请认真填写
        </p>
        <el-form-item label="主要科目" prop="mainSubjectIds">
          <el-select
            v-model="formInformation.mainSubjectIds[0]"
            clearable
            placeholder="请选择主要科目一"
            style="width: 100%; margin: 0 0 10px 0"
          >
            <el-option
              v-for="item in subject_s"
              :key="item.ordinal"
              :label="item.name"
              :value="item.ordinal"
              :disabled="formInformation.mainSubjectIds.includes(item.ordinal)"
            >
            </el-option>
          </el-select>

          <el-select
            v-model="formInformation.mainSubjectIds[1]"
            clearable
            placeholder="请选择主要科目二"
            style="width: 100%; margin: 0 0 10px 0"
          >
            <el-option
              v-for="item in subject_s"
              :key="item.ordinal"
              :label="item.name"
              :value="item.ordinal"
              :disabled="formInformation.mainSubjectIds.includes(item.ordinal)"
            >
            </el-option>
          </el-select>
          <el-select
            v-model="formInformation.mainSubjectIds[2]"
            clearable
            placeholder="请选择主要科目三"
            style="width: 100%; margin: 0 0 0px 0"
          >
            <el-option
              v-for="item in subject_s"
              :key="item.ordinal"
              :label="item.name"
              :value="item.ordinal"
              :disabled="formInformation.mainSubjectIds.includes(item.ordinal)"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <p class="Information_p">
          主要科目决定在主页中除语文、数学、英语外的优先显示科目，在个人设置中可随时更改。
          如为中学生，建议您选择中高考应试科目。
        </p>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          style="background: #169bd5"
          type="primary"
          @click="submitSave('formInformation')"
          >保 存</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import ComFooter from "@/components/ComFooter.vue";
export default {
  inject: ["reloads_"],
  components: { ComFooter },
  data() {
    return {
      dialogFormIllustrate: true,
      Illustrate: 0,
      maxStep: 3,
      dialogFormInformation: false,
      formInformation: {
        nickname: "",
        stageId: "",
        gradeId: "",
        provinceId: "",
        cityId: "",
        countyId: "",
        mainSubjectIds: ["", "", ""],
      },
      rulesInformation: {
        nickname: [
          { required: true, message: "请输入昵称", trigger: "blur" },
          {
            min: 3,
            max: 15,
            message: "长度在 3 到 15 个字符",
            trigger: "blur",
          },
        ],
        stageId: [{ required: true, message: "请选择学段", trigger: "change" }],
        // gradeId: [{ required: true, message: "请选择年级", trigger: "change" }],
        provinceId: [
          { required: true, message: "请选择地区", trigger: "change" },
        ],
        // mainSubjectIds: [{ validator: this.validateSubjects, trigger: "blur" }],
      },
      stagesOptions: [],
      gradesOptions: [],
      provinceOptions: [],
      subjectsOptions: [],
      show_or: true,
      dialogFormLogin: false,
      formLabelWidth: "80px",
      formLogin: {
        phone: "",
        code: "",
      },
      rulesLogin: {
        phone: [
          { required: true, message: "请输入手机号", trigger: "blur" },
          {
            pattern: /^1[3456789]\d{9}$/,
            message: "手机号格式不正确",
            trigger: "blur",
          },
        ],
        code: [{ required: true, message: "请输入验证码", trigger: "blur" }],
      },
      countDown: 0,
      majorSubjects: [
        {
          name: "物理",
          ordinal: 4,
          id: 4,
        },
        {
          name: "化学",
          ordinal: 5,
          id: 5,
        },
        {
          name: "生物",
          ordinal: 6,
          id: 6,
        },
      ],
      otherSubjects: [
        {
          name: "政治",
          ordinal: 7,
          id: 7,
        },
        {
          name: "历史",
          ordinal: 8,
          id: 8,
        },
        {
          name: "地理",
          ordinal: 9,
          id: 9,
        },
      ],
      subject_s: [
        {
          id: 4,
          name: "物理",
          ordinal: 4,
        },
        {
          id: 5,
          name: "化学",
          ordinal: 5,
        },
        {
          id: 6,
          name: "生物",
          ordinal: 6,
        },
        {
          id: 7,
          name: "政治",
          ordinal: 7,
        },
        {
          id: 8,
          name: "历史",
          ordinal: 8,
        },
        {
          id: 9,
          name: "地理",
          ordinal: 9,
        },
      ],
      login_show: true,
      user: "",
      org_code: "",
    };
  },
  created() {
    this.basisData();
    if (this.$route.query.orgCode) {
      localStorage.setItem("orgCode_copy", this.$route.query.orgCode);
      this.org_code = this.$route.query.orgCode;
    } else {
      if (localStorage.getItem("orgCode_copy")) {
        this.org_code = localStorage.getItem("orgCode_copy");
      } else {
        this.org_code = "BJYKQXKJ001";
      }
    }
    sessionStorage.removeItem("conversation");

    if (localStorage.getItem("tokenChat")) {
      this.login_show = false;
      this.dialogFormIllustrate = false;
      // if()
      if (sessionStorage.getItem("user_info")) {
        let user = JSON.parse(sessionStorage.getItem("user_info"));
        if (user.nickname && user.stage && user.stage.id) {
          if (sessionStorage.getItem("majorSubjects")) {
            this.majorSubjects = JSON.parse(
              sessionStorage.getItem("majorSubjects")
            );
          } else {
            sessionStorage.setItem(
              "majorSubjects",
              JSON.stringify(this.majorSubjects)
            );
          }
          if (sessionStorage.getItem("otherSubjects")) {
            this.otherSubjects = JSON.parse(
              sessionStorage.getItem("otherSubjects")
            );
          } else {
            sessionStorage.setItem(
              "otherSubjects",
              JSON.stringify(this.otherSubjects)
            );
          }
        } else {
          this.dialogFormInformation = false;
        }
      } else {
        this.dialogFormInformation = false;
      }
    }

    // console.log('a',this.$route.query.orgCode ,this.org_code)
  },
  mounted() {},
  methods: {
    basisData() {
      this.$api.basicData
        .areasBasic({ parentId: 0 })
        .then((res) => {
          // console.log(res);
          if (res.code == 0) {
            this.provinceOptions = res.data;
          }
        })
        .catch((err) => {
          console.log(err);
        });

      this.$api.basicData
        .stagesBasic()
        .then((res) => {
          // console.log(res);
          if (res.code == 0) {
            this.stagesOptions = res.data;
          }
        })
        .catch((err) => {
          console.log(err);
        });
      // this.$api.basicData
      //   .gradesBasic()
      //   .then((res) => {
      //     console.log(res);
      //   })
      //   .catch((err) => {
      //     console.log(err);
      //   });
      this.$api.basicData
        .subjectsBasic()
        .then((res) => {
          // console.log(res);
          if (res.code == 0) {
            this.subjectsOptions = res.data;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    stagesChange(e) {
      this.formInformation.gradeId = "";
      console.log(
        this.formInformation.stageId,
        this.formInformation.stageId == 2 ||
          this.formInformation.stageId == 3 ||
          this.formInformation.stageId == 4
      );
      if (
        this.formInformation.stageId == 2 ||
        this.formInformation.stageId == 3 ||
        this.formInformation.stageId == 4
      ) {
        this.$api.basicData
          .gradesBasic({
            division: "G63",
            stageId: this.formInformation.stageId,
          })
          .then((res) => {
            // console.log(res);
            if (res.code == 0) {
              this.gradesOptions = res.data;
            }
          })
          .catch((err) => {
            console.log(err);
          });
      }
    },
    nextStep() {
      if (this.Illustrate < this.maxStep) {
        this.Illustrate++;
      } else {
        this.dialogFormIllustrate = false;
        this.dialogFormLogin = true;
        // this.dialogFormInformation = true;
      }
    },
    prevStep() {
      if (this.Illustrate > 0) {
        this.Illustrate--;
      }
    },
    countdown() {
      this.countDown = 60;
      const timer = setInterval(() => {
        this.countDown--;
        if (this.countDown <= 0) {
          clearInterval(timer);
          this.countDown = 0;
        }
      }, 1000);
    },
    validateSubjects(rule, value, callback) {
      // 验证数组中是否有重复的元素
      const hasDuplicates = new Set(value).size !== value.length;

      if (hasDuplicates) {
        callback(new Error("主要科目不能选择相同的科目"));
      } else if (
        value.includes("") ||
        value.includes(undefined) ||
        value.includes(null)
      ) {
        callback(new Error("主要科目不能为空"));
      } else {
        callback();
      }
    },
    //
    submitSave(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // alert("submit!");
          for (
            var i = this.formInformation.mainSubjectIds.length - 1;
            i >= 0;
            i--
          ) {
            if (this.formInformation.mainSubjectIds[i] == "") {
              this.formInformation.mainSubjectIds.splice(i, 1);
            }
          }
          if (
            this.formInformation.mainSubjectIds &&
            this.formInformation.mainSubjectIds.length > 0
          ) {
            this.majorSubjects = [];
            this.otherSubjects = [];
            this.subject_s.forEach((item, index) => {
              if (this.formInformation.mainSubjectIds.indexOf(item.id) !== -1) {
                // console.log('a',item)
                this.majorSubjects.push(item);
              } else {
                // console.log('b',item)
                this.otherSubjects.push(item);
              }
            });
            this.$nextTick(function () {
              sessionStorage.setItem(
                "majorSubjects",
                JSON.stringify(this.majorSubjects)
              );
              sessionStorage.setItem(
                "otherSubjects",
                JSON.stringify(this.otherSubjects)
              );
            });
          }

          // return;
          this.$api.basicData
            .editProfile(this.formInformation)
            .then((res) => {
              // console.log(res);
              if (res.code == 0) {
                // this.gradesOptions = res.data;
                this.dialogFormInformation = false;

                this.$message({
                  message: "登录成功！",
                  type: "success",
                });
                // this.$Toast("修改成功！");
              }
            })
            .catch((err) => {
              console.log(err);
            });
          // this.dialogFormLogin = false;
        } else {
          // console.log("error submit!!");
          return false;
        }
      });
    },
    // 登录
    loginUser() {
      this.formLogin = {
        phone: "",
        code: "",
      };
      this.countDown = 0;
      this.dialogFormLogin = true;
    },
    submitLogin(formName) {
      // this.dialogFormLogin = false;
      // this.dialogFormInformation = true;
      // return;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // alert("submit!");

          // this.countdown();
          this.$api.basicData
            .loginProfile({
              phone: this.formLogin.phone,
              code: this.formLogin.code,
              source: this.org_code,
            })
            .then((res) => {
              // console.log(res);
              if (res.code == 0) {
                // this.$message({
                //   message: "登录成功！",
                //   type: "success",
                // });
                // this.$Toast("登录成功！");
                sessionStorage.setItem("tokenChat", res.data.token);
                localStorage.setItem("tokenChat", res.data.token);
                // this.login_show = false;
                // // this.reloads_();
                // this.dialogFormLogin = false;
                // this.dialogFormInformation = true;
                this.getUser();
              }
            })
            .catch((err) => {
              console.log(err);
            });
        } else {
          // console.log("error submit!!");
          return false;
        }
      });
    },
    getUser() {
      this.$api.basicData
        .infoProfile()
        .then((res) => {
          // console.log(res);
          if (res.code == 0) {
            this.user = res.data;
            sessionStorage.setItem("user_info", JSON.stringify(this.user));
            this.formInformation.nickname = this.user.nickname;
            if (this.user.stage) {
              this.formInformation.stageId = this.user.stage.id;
            }

            if (this.formInformation.stageId) {
              this.stagesChange();
            }
            if (this.user.grade) {
              this.formInformation.gradeId = this.user.grade.id;
            }
            if (this.user.province) {
              this.formInformation.provinceId = this.user.province.id;
            }

            this.formInformation.mainSubjectIds = ["", "", ""];
            if (this.user.mainSubjects) {
              this.user.mainSubjects.forEach((item, index) => {
                if (item.id) {
                  this.formInformation.mainSubjectIds[index] = item.id;
                }
              });
              // this.formInformation.mainSubjectIds = this.user.mainSubjects;
            }
            this.login_show = false;
            // this.reloads_();
            this.dialogFormLogin = false;
            if (!this.user.mainSubjects) {
              this.dialogFormInformation = true;
            }
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getCode() {
      this.$refs.formLogin.validateField("phone", (errMsg) => {
        if (!errMsg) {
          this.countdown();
          this.$api.basicData
            .sendCode({ phone: this.formLogin.phone })
            .then((res) => {
              // console.log(res);
              if (res.code == 0) {
              }
            })
            .catch((err) => {
              console.log(err);
            });
        }
      });
    },
    goSearch(item) {
      this.$router.push({
        name: "QuerySearch",
        query: { type: item.name, subjectsId: item.id },
      });
    },
    goKind(item) {
      this.$router.push({
        name: "KindSearch",
        query: { type: item.name, subjectsId: item.id },
      });
    },
    goBasket() {
      this.$router.push({
        name: "BasketQuestions",
      });
    },
    goPersonal() {
      this.$router.push({
        name: "CenterPersonal",
      });
    },
    goMedia() {
      this.$router.push({
        name: "ChatMedia",
      });
    },
  },
};
</script>
<style scoped lang='less'>
.home {
  background: white;
  min-height: 100vh;
  padding: 0 20px 40px 20px;
}
.home_header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 70px;
  line-height: 70px;
  padding: 0 0px;
}
.home_left {
  font-weight: 600;
  font-size: 20px;
  letter-spacing: 1px;
}
.subject_car {
  box-shadow: 0 2px 12px 0 rgb(0 0 0 / 10%);
  border-radius: 10px;
  border: 1px solid #ebeef5;
  background-color: rgb(255, 255, 255);
  overflow: hidden;
  padding: 15px;
  margin: 0 0 20px 0;
  // max-width: 95%;
}
.car_tit {
  display: flex;
  align-items: center;
}
.tit_txt {
  font-weight: 600;
  font-size: 18px;
  letter-spacing: 1px;
}
.car_box {
  margin: 20px 0 0 0;
  display: flex;
  justify-content: space-between;
  .compulsory_left {
    width: 49%;
    background: #de82a7;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    border-radius: 5px;
    padding: 18px 15px;
  }
  .compulsory_tit {
    font-weight: 600;
    font-size: 16px;
    letter-spacing: 1px;
  }
  .compulsory_right {
    width: 49%;
  }
  .compulsory_right_son {
    width: 100%;
    height: 140px;
    border-radius: 5px;
    padding: 18px 15px;
    margin: 0 0 0 0;
    // display: flex;
    // justify-content: space-between;
    .img_r {
      display: flex;
      // flex-direction: column;
      justify-content: center;
    }
  }
}
.major_s {
  display: flex;
  justify-content: space-around;
  background: #e5f3d5;
  border-radius: 5px;
  padding: 18px 15px;
  margin: 10px 0 0 0;
  .major_son {
    width: 30%;
    max-width: 85px;
    .major_img {
      width: 100%;
      max-width: 85px;
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 10px 0;
      border-radius: 5px;
      img {
        max-width: 65px;
        width: 70%;
      }
    }

    .major_tit {
      text-align: center;
      line-height: 25px;
      font-weight: 600;
      color: #5a842f;
      letter-spacing: 1px;
    }
  }
}
.other_s {
  display: flex;
  flex-wrap: wrap;
  // justify-content: space-around;
  margin: 10px 0;
}
.other_ {
  width: 33%;
  display: flex;
  justify-content: center;
}
.other_tag {
  // width: 30%;
  width: 90%;
  background-color: #ecf5ff;
  display: inline-block;
  height: 32px;
  padding: 0 10px;
  line-height: 30px;
  font-size: 12px;
  color: #409eff;
  border: 1px solid #d9ecff;
  border-radius: 4px;
  box-sizing: border-box;
  white-space: nowrap;
  margin: 10px 0 0 0;
  text-align: center;
  overflow: hidden;
}
.levitating_css {
  position: fixed;
  right: 30px;
  bottom: 20px;
  z-index: 999;
}
.ball_s {
  display: flex;
}
.ball_css {
  width: 50px;
  height: 50px;
  // line-height: 50px;
  // text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  background: #8f5ad5;

  margin: 0 0 0 10px;
  span {
    font-size: 12px;
    color: #ffffff;
    font-weight: 600;
  }
}
/deep/ .el-dialog__header {
  display: none;
}
/deep/ .el-dialog {
  width: 80%;
  max-width: 350px;
  // background: #ecf9fa;
  border-radius: 10px;
}

.dialog_tit {
  font-weight: 600;
  font-size: 21px;
  letter-spacing: 1px;
  line-height: 60px;
  text-align: center;
}
.dialogLogin {
  /deep/ .el-dialog__body {
    padding: 0px 20px;
  }
  .dialog-footer {
    display: flex;
    justify-content: center;
  }
}
.dialogIllustrate,
.dialogInformation {
  /deep/ .el-dialog__body {
    padding: 0px 0px;
  }
  .dialog_tit {
    border-start-start-radius: 10px;
    border-start-end-radius: 10px;
    color: #ffffff;
    letter-spacing: 2px;
    font-size: 20px;
  }
  .dialog-footer {
    display: flex;
    justify-content: space-around;
  }
}
.conIllustrate {
  margin: 20px 20px 15px 20px;
  height: 350px;
}
.imgIllustrate {
  max-height: 200px;
  min-height: 100px;
}
.Illustrate_p {
  text-indent: 2em;
  line-height: 20px;
  margin: 3px 0;
  color: #3d3d3d;
}
.form_css::-webkit-scrollbar {
  display: none;
}
.form_css {
  height: calc(90vh - 180px);
  overflow-x: hidden;
  overflow-y: scroll;
}
.conIllustrate_css::-webkit-scrollbar {
  display: none;
}
.conIllustrate_css {
  max-height: calc(90vh - 350px);
  overflow-x: hidden;
  overflow-y: scroll;
}
.dialogInformation {
  /deep/ .el-dialog {
    margin-top: 8vh !important;
  }
  /deep/ .el-form-item {
    margin-bottom: 10px;
  }
  /deep/ .el-form-item__label {
    line-height: 30px;
    font-weight: 600;
  }
  .Information_p {
    line-height: 20px;
    font-size: 10px !important;
    color: #a1a1a1;
    // display: inline-block;
    padding: 5px 0 0 0;
  }
}
.Media_css {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 10px 0px 5px 10px;
  p {
    color: #d3d4d6;
    font-size: 12px;
    zoom: 0.85;
    // line-height: 20px;
    margin: 10px 0 0 0;
  }
  .Media_right {
    img {
      width: 38px;
    }
  }
}
.dia_img {
  width: 100%;
}
</style>
